'use strict';

exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ORIENTATIONS$HORIZON, _ORIENTATIONS$VERTICA, _directionsMap;

var _eventemitter = require('eventemitter3');

var _constants = require('../constants');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var directionsMap = (_directionsMap = {}, _directionsMap[_constants.ORIENTATIONS.HORIZONTAL] = (_ORIENTATIONS$HORIZON = {}, _ORIENTATIONS$HORIZON[_constants.ANCHOR_POINTS.TOP_LEFT] = _constants.DIRECTIONS.STANDARD, _ORIENTATIONS$HORIZON[_constants.ANCHOR_POINTS.TOP_RIGHT] = _constants.DIRECTIONS.REVERSE, _ORIENTATIONS$HORIZON[_constants.ANCHOR_POINTS.BOTTOM_LEFT] = _constants.DIRECTIONS.STANDARD, _ORIENTATIONS$HORIZON[_constants.ANCHOR_POINTS.BOTTOM_RIGHT] = _constants.DIRECTIONS.REVERSE, _ORIENTATIONS$HORIZON), _directionsMap[_constants.ORIENTATIONS.VERTICAL] = (_ORIENTATIONS$VERTICA = {}, _ORIENTATIONS$VERTICA[_constants.ANCHOR_POINTS.TOP_LEFT] = _constants.DIRECTIONS.STANDARD, _ORIENTATIONS$VERTICA[_constants.ANCHOR_POINTS.TOP_RIGHT] = _constants.DIRECTIONS.STANDARD, _ORIENTATIONS$VERTICA[_constants.ANCHOR_POINTS.BOTTOM_LEFT] = _constants.DIRECTIONS.REVERSE, _ORIENTATIONS$VERTICA[_constants.ANCHOR_POINTS.BOTTOM_RIGHT] = _constants.DIRECTIONS.REVERSE, _ORIENTATIONS$VERTICA), _directionsMap);

var CardsConfig = function (_EventEmitter) {
  _inherits(CardsConfig, _EventEmitter);

  function CardsConfig() {
    _classCallCheck(this, CardsConfig);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this._orientation = _constants.ORIENTATIONS.HORIZONTAL;
    _this._anchorPoint = _constants.ANCHOR_POINTS.BOTTOM_LEFT;
    _this._isPreviewMode = false;
    return _this;
  }

  CardsConfig.prototype.onChange = function onChange(callback, context) {
    this.on(_constants.EVENTS.CONFIG_CHANGED, callback, context);
  };

  CardsConfig.prototype.destroy = function destroy() {
    var _this2 = this;

    this.eventNames().forEach(function (eventName) {
      _this2.removeAllListeners(eventName);
    });
  };

  _createClass(CardsConfig, [{
    key: 'orientation',
    get: function get() {
      return this._orientation;
    },
    set: function set(value) {
      this._orientation = value;
      this.emit(_constants.EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: 'anchorPoint',
    get: function get() {
      return this._anchorPoint;
    },
    set: function set(value) {
      this._anchorPoint = value;
      this.emit(_constants.EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: 'isPreviewMode',
    get: function get() {
      return this._isPreviewMode;
    },
    set: function set(value) {
      this._isPreviewMode = value;
      this.emit(_constants.EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: 'direction',
    get: function get() {
      var anchorPoint = this.anchorPoint,
          orientation = this.orientation;

      return directionsMap[orientation][anchorPoint];
    }
  }]);

  return CardsConfig;
}(_eventemitter.EventEmitter);

exports.default = CardsConfig;